import styled, { css } from "styled-components";
import { ArrowIcon } from "../../materials/icons/arrow-icon/ArrowIcon";
import { staticText } from "../../shared/statics/static-text";
import {
  elevation00,
  shade0,
  shade700,
  shade900,
  shade950,
} from "../../styles/tokens";
import { Body } from "../body/Body";

// TEXT
export const text = staticText.backButton;

// STYLES
/**
 * Responsible for maintaining proper relative position for the component
 * otherwise the button will be absolutely positioned. Works in tandem with the Expander
 */
export const Container = styled.div`
  display: flex;
  min-width: 2rem;
  min-height: 2rem;
`;

/**
 * Need this absolutely positioned container so that the button will expand
 * to the right instead of from the center in both directions (left and right)
 */
export const Expander = styled.div`
  position: absolute;
`;

export const BackButtonContent = styled.button<BackButtonContentProps>`
  padding: 0;
  height: 2rem;
  width: 2rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  overflow: hidden;
  background-color: transparent;
  border: 1px solid ${shade900};
  border-radius: 100%;
  white-space: nowrap;

  small {
    opacity: 0;
    margin-bottom: 0.125rem;
  }

  &:focus-visible {
    border: none;
  }

  &[disabled],
  &:disabled {
    ${({ disabled }: BackButtonContentProps) => {
      return disabled === "functional"
        ? css`
            cursor: default;
            width: 100%;
            border-radius: 3rem;
            small {
              opacity: 1;
            }
            > svg {
              color: ${shade0};
            }
            box-shadow: ${elevation00};
          `
        : css`
            svg {
              color: ${shade700};
            }
            cursor: not-allowed;
          `;
    }}
  }

  @media (hover: hover) {
    &:focus-visible:not(:disabled),
    &:hover:not(:disabled) {
      background-color: ${shade950};
      width: 100%;
      border-radius: 3rem;
      small {
        opacity: 1;
      }
      > svg {
        color: ${shade0};
      }
      transition:
        width 0.2s linear,
        box-shadow 0.2s linear;

      box-shadow: ${elevation00};
    }

    &:focus-visible:not(:disabled) {
      outline: 2px solid ${shade0};
      outline-offset: 2px;
    }
  }

  transition:
    width 0.2s linear,
    border-radius 0.2s linear,
    box-shadow 0.2s linear,
    color 0.2s linear;
`;

export const Icon = styled(ArrowIcon)`
  width: 0.75rem;
  margin-top: 0.0625rem;
  margin-left: 0.5625rem;
  flex: none;
  color: ${shade0};
`;

export const Text = styled(Body)`
  transition: opacity 0.3s linear;
  color: ${shade0};
  margin-right: 0.5rem;
`;

// DATA

// TYPES
export type BackButtonContentProps = {
  label?: string;
  disabled?: boolean | "functional";
};

// CONSTANTS

// FUNCTIONS

// ASSETS
